import { CollabSchema } from '@common/prosemirror/model/collab-schema';
import { getTrackedChangesState, TrackedChangesTrackedMetaKey } from '@common/prosemirror/plugins/tracked-changes.plugin';
import { ChangeType } from '@common/prosemirror/tracked-changes/change-type.enum';
import { copySliceWithChanges } from '@common/prosemirror/tracked-changes/copy';
import { NodeType } from 'prosemirror-model';
import { Command, EditorState, Selection } from 'prosemirror-state';

export function insertBr(brType: NodeType): Command {
  return function (state: EditorState, dispatch?: ProsemirrorDispatcher): boolean {
    const selection = state.selection;

    // Only insert a br if the selection is in inline content and the selection start and end are in the same parent node
    if (!selection.$from.parent.inlineContent || !selection.$from.sameParent(selection.$to)) {
      return false;
    }

    if (dispatch) {
      const trackedChangesState = getTrackedChangesState(state);
      const tr = state.tr;

      if (trackedChangesState?.enabled) {
        // Insert a tracked removal for the selection
        tr.replaceSelection(copySliceWithChanges((state.schema as CollabSchema).changeMark, tr.doc.slice(selection.from, selection.to), trackedChangesState.makeTrackedChangeNodeAttrs(ChangeType.Remove)));

        // Insert a tracked add for the br
        tr.insert(selection.from, brType.create(trackedChangesState.makeTrackedChangeNodeAttrs(ChangeType.Add)));

        // Set the selection just after the br
        tr.setSelection(Selection.near(tr.doc.resolve(selection.from + 1)));

        // Mark that the changes were tracked
        tr.setMeta(TrackedChangesTrackedMetaKey, true);
      } else {
        tr.replaceSelectionWith(brType.create());
      }

      dispatch(tr.scrollIntoView());
    }

    return true;
  };
}
